export interface GameRuntimeLoadResult {
    Game: typeof import('./core/Game.js').Game;
}

let gameModulePromise: Promise<GameRuntimeLoadResult> | null = null;
let managerRuntimePromise: Promise<typeof import('./manager/ManagerRuntimeController.js')> | null = null;

export function clearRuntimeCaches(): void {
    gameModulePromise = null;
    managerRuntimePromise = null;
}

export async function loadGameRuntime(): Promise<GameRuntimeLoadResult> {
    if (!gameModulePromise) {
        gameModulePromise = import('./core/Game.js');
    }
    return gameModulePromise;
}

export async function loadManagerRuntimeController(): Promise<typeof import('./manager/ManagerRuntimeController.js')> {
    if (!managerRuntimePromise) {
        managerRuntimePromise = import('./manager/ManagerRuntimeController.js');
    }
    return managerRuntimePromise;
}
